/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Use_Legacy_ButtonInputs */



/**
* | output |
* | --- |
* | "Use Legacy Timeline" |
*
* @param {Timeline_Use_Legacy_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_use_legacy_button = /** @type {((inputs?: Timeline_Use_Legacy_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Use_Legacy_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utiliser la chronologie heritee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Legacy-Zeitleiste verwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Usa la cronologia legacy")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Используйте устаревшую временную шкалу.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usar la línea de tiempo heredada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用旧版时间线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レガシータイムラインを使用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लेगेसी टाइमलाइन का उपयोग करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Usar a linha do tempo legada")
	return /** @type {LocalizedString} */ ("Use Legacy Timeline")
});